import axios from 'axios';
import { Platform, fallbackToConsumerToken } from '@aviata/platform-client';
import type { AxiosStatic } from '@aviata/platform-client';

const TIMEOUT = 120000;

function createPfm() {
  const config = {
    baseURL: import.meta.env.VITE_PFM_BASE_URL,
    headers: {},
    /**
     * Using hardcoded token, because it is not necessary to generate it for debug bar app.
     * It has long expiration period, so we can always use the same consumer.
     * */
    consumer: {
      name: '',
      key: '',
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI0MDNiZGYwMS1iMTg1LTQwNDUtOGM5Ny02NTEwMmIzOWI4ODciLCJpc3MiOiJSR013VnlMUzN6T1gycTQzREpmSGUxUGVCSjlaTFgzMSIsImlhdCI6MTcwMTI0MzQyMiwiZXhwIjozMDI1NzU1NDIyLCJjb25zdW1lciI6eyJpZCI6Ik5vbmUiLCJuYW1lIjoiYXZpYXRhLWt6LmZyZWVkb20uc3VwZXJhcHAuYW5kcm9pZCJ9fQ.Xoqv8TzFPIDoOW2oejofyGf85SQZh95G7MYPEk8Frj0',
    },
    user: {
      required: true,
    },
    timeout: TIMEOUT,
    initStrategy: fallbackToConsumerToken,
  };

  return Platform(axios as AxiosStatic, config);
}

export const pfm = createPfm();
